import React from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import {
  MoreHoriz as MoreIcon,
  VisibilityOutlined as ViewIcon,
  DescriptionOutlined as ManageIcon,
} from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { setAccruals } from "../../../features/general journal/accruals-all.slice";
import { PrintIcon } from "../../../assets/icons/icons";
import { useQueryParams } from "../../../hooks/useQueryParams";

const DocumentGeneralJournalAccrualReversalActions = ({
  data,
  year,
  onView = () => {},
  onManage = () => {},
  onPrint = () => {},
}) => {
  const [anchor, setAnchor] = React.useState(null);
  const dispatch = useDispatch();
  const { searchParams } = useQueryParams();
  const is_reversed = searchParams.get("is_reversed");

  const actionOpenHandler = (event) => {
    setAnchor(event.currentTarget);
  };

  const actionCloseHandler = () => {
    setAnchor(null);
  };

  return (
    <React.Fragment>
      <IconButton size="small" onClick={actionOpenHandler}>
        <MoreIcon />
      </IconButton>

      <Menu
        open={Boolean(anchor)}
        elevation={2}
        anchorEl={anchor}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        MenuListProps={{
          sx: { py: 0.5 },
        }}
        onClose={actionCloseHandler}
        disablePortal
      >
        {!Boolean(Number(is_reversed)) ? (
          <MenuItem
            sx={{ fontWeight: 500 }}
            onClick={() => {
              onManage(data);
              actionCloseHandler();
              dispatch(setAccruals({ year: year, data: data, is_filtered: false }));
            }}
            dense
          >
            <ManageIcon sx={{ fontSize: 21, marginRight: 1, opacity: 0.75 }} /> Manage
          </MenuItem>
        ) : null}

        {Boolean(Number(is_reversed)) || Boolean(Number(is_reversed)) ? (
          <MenuItem
            sx={{ fontWeight: 500 }}
            onClick={() => {
              onView(data);
              dispatch(setAccruals({ year: year, data: data, is_filtered: false }));
              actionCloseHandler();
            }}
            dense
          >
            <ViewIcon sx={{ fontSize: 21, marginRight: 1, opacity: 0.75 }} /> View
          </MenuItem>
        ) : null}

        {Boolean(Number(is_reversed)) || Boolean(Number(is_reversed)) ? (
          <MenuItem
            sx={{ fontWeight: 500 }}
            onClick={() => {
              onPrint(data);
              actionCloseHandler();
            }}
            dense
          >
            <PrintIcon sx={{ fontSize: 21, marginRight: 1, opacity: 0.75 }} /> Print
          </MenuItem>
        ) : null}

        {/* <MenuItem
     sx={{ fontWeight: 500 }}
     onClick={() => {
      onDelete(data.id);
      actionCloseHandler();
     }}
     dense
    >
     <DeleteIcon sx={{ fontSize: 21, marginRight: 1, opacity: 0.75 }} /> Delete
    </MenuItem> */}
      </Menu>
    </React.Fragment>
  );
};

export default DocumentGeneralJournalAccrualReversalActions;
